"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyBy = keyBy;
const lodash_1 = require("lodash");
/**
 * Properly sets nullable type for members which is currently not done by
 * native lodash types
 * @param items
 * @param keyOrCallback
 * @returns
 */
function keyBy(items, keyOrCallback) {
    if (typeof keyOrCallback === 'string') {
        return (0, lodash_1.keyBy)(items, keyOrCallback);
    }
    return (0, lodash_1.keyBy)(items, keyOrCallback);
}
//# sourceMappingURL=key-by.js.map